<template>
<div>
  <sub-header :headerItems="headerItems"/>
<sub-slider/>
  <div v-scroll-reveal.reset class="text-center mt-16 mb-16" dir="auto">
    <h1  class="one font-weight-bold">محصولات</h1>
  </div>
  <products-grid/>
  <div v-scroll-reveal.reset class="text-center my-16" dir="auto">
    <h1 class="font-weight-bold">{{ $t('stone') }}</h1>
    <h4 style="text-align:center; width: 38%;" class="mx-auto">
      {{ $t('stone-subtitle') }}
    </h4>
    <h4 style="text-align:center; width: 38%;" class="mx-auto">
      {{ $t('stone-subtitle-line-two') }}
    </h4>
  </div>
  <div v-scroll-reveal.reset class="text-center mt-16 mb-16" dir="auto">
    <h1  class="one font-weight-bold">دانلودها</h1>
  </div>
  <download/>
  <div v-scroll-reveal.res`et class="text-center mt-16 mb-16" dir="auto">
    <h1  class="one font-weight-bold">پروژه ها</h1>
  </div>
  <projects/>
  <div v-scroll-reveal.reset class="text-center mt-16 mb-16" dir="auto">
    <h1  class="one font-weight-bold">گواهینامه ها و استانداردها</h1>
  </div>
  <certificate/>
</div>
</template>

<script>
import productsGrid from "./components/productsGrid";
import Projects from "./components/projects";
import Certificate from "./components/certificate";
import Download from "./components/download";
import {mapState} from "vuex";


export default {
  name: "glass",
  components: {Download, Certificate, Projects, productsGrid},
  data(){
    return{
      headerItems:[
        {
          name:'صفحه اصلی',
          type:'single',
          route:'/',
          subDomain:[]
        },
        {
          name:'درباره ما',
          type:'sublayer',
          route:'',
          subDomain:[
            {
              name:'تاریخچه',
              route:'/history'
            },
            {
              name:'مدیریت',
              route:'/management'
            },
            {
              name:'گواهینامه‌ها و افتخارات',
              route:'/certificates'
            },
            {
              name:'صادرات',
              route:'/export'
            },
          ]
        },
        {
          name:'محصولات',
          type:'sublayer',
          route:'',
          subDomain: [
            {
              name:'سوپرکلییر',
              route:''
            },
            {
              name:'صنایع جانبی',
              route:''
            },
            {
              name:'شیشه های صنعتی',
              route:''
            },
            {
              name:'شیشه های High Performance',
              route:'/sub/cement-block'
            },
          ]
        },

        {
          name:'اخبار',
          type:'sublayer',
          route:'',
          subDomain:[
            {
              name:'رویداد‌ها و نمایشگاه ها',
              route:'/show-place'
            },
            {
              name:'پروژه ها',
              route:'/projects'
            },
            {
              name:'مقالات',
              route:'/news'
            },
            {
              name: 'گالری',
              route: '/gallery'
            },
          ]
        },
        {
          name:'سوالات متداول',
          type:'single',
          route:'/FAQ',
          subDomain:[]
        },
        {
          name:'نماینذگی ها',
          type:'sublayer',
          route:'',
          subDomain:[
            {
              name:'درخواست همکاری',
              route:''
            },
            {
              name:'شرایط نماینذگی',
              route:''
            },
            {
              name:'لیست نماینذگی ها',
              route:''
            }
          ]
        },
        {
          name:'تماس با ما',
          type:'single',
          route:'/',
          subDomain:[]
        },
        //   {
        //   name:'تماس با ما',
        //   type:'single',
        //   route:'contact-us',
        //   subDomain:[]
        // },

      ],
      fakeList: [
        {
          'img': require('../../../assets/images/news-images/DSC2165-1024x683.jpg'),
          'date': 'تهران، ایران –  ۱۳۹۷',
          'content': 'نمایشگاه در و پنجره'
        },
        {
          'img': require('../../../assets/images/news-images/4.jpg'),
          'date': 'دوسلدورف، آلمان – 2018\n',
          'content': 'نمایشگاه گلس تک'
        },
        {
          'img': require('../../../assets/images/news-images/4d70a297-1b24-4f47-913e-60f3ab9e4598-1.jpg'),
          'date': '۲۴فرانکفورت، آلمان – 2018',
          'content': 'نمایشگاه ambiente'
        }
      ],
    }
  },
  computed:{
    ...mapState({
      sliderItems:state => state.lightBlocksManagement.blockHomeBanner,
    })
  },
  created() {
    this.$store.dispatch('lightBlocksManagement/getBlockHomeBanner');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeCatalogue');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeFeatures');
    this.$store.dispatch('lightBlocksManagement/getBlockNews',{
      page:1
    });
    this.$store.dispatch('lightBlocksManagement/getBlockProjects');
    this.$store.dispatch('lightBlocksManagement/getBlockProducts');
  }
}
</script>


